<template src="./form.html"></template>

<script>
import { CreateSite } from '@/api/site'

export default {
  name: 'add-site',
  data: function () {
    return {
      model: {
        studyid: this.$route.params.id,
        invid: '',
        site_name: '',
        number: null
      },
      ruleValidate: {
        site_name: [{
          required: true,
          message: '研究单位不能为空',
          trigger: 'change'
        }],
        invid: [{
          required: true,
          message: '中心编号不能为空',
          trigger: 'change'
        }],
        number: [{
          type: 'number',
          message: '样本量必须是数字',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateSite(this.model).then(async res => {
        if (res.id) {
          this.$Message.success('已添加到成员列表！')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
